var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useTheme } from 'styled-components';
import { useApp } from '../../contexts/App';
import { classNames } from '../../utils/styles';
import { Button, SectionContainer, SectionTitle } from '../styles';
import { Modal } from './components/Modal';
import { Spinner } from './components/Spinner';
import { SuccessModalContent } from './components/SuccessModalContent';
import { ContentContainer, FormGroup } from './styles';
import { autoResizeTextArea, preLoadImgIfIsRunningOnBrowser, safeBase64Encode, } from './utils';
export var Form = function (_a) {
    var section = _a.section;
    var fields = section.fields;
    var theme = useTheme();
    var contextProps = useApp().contextProps;
    var _b = useState(''), name = _b[0], setName = _b[1];
    var _c = useState(''), email = _c[0], setEmail = _c[1];
    var _d = useState(''), phone = _d[0], setPhone = _d[1];
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    var _f = useState(false), showModal = _f[0], setShowModal = _f[1];
    var _g = useState(true), isSubmitting = _g[0], setSubmitting = _g[1];
    var _h = useState(false), showMessageFormError = _h[0], setShowMessageFormError = _h[1];
    var _j = useState(''), invalidFormSvgUrl = _j[0], setInvalidFormSvgUrl = _j[1];
    useEffect(function () {
        var invalidFormSvgUrl = contextProps.hostApi + "/utils/svg/invalid-form-svg?bgColor=" + safeBase64Encode(theme.secondary);
        setInvalidFormSvgUrl(invalidFormSvgUrl);
        preLoadImgIfIsRunningOnBrowser(invalidFormSvgUrl);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var isFormOk = function () {
        if (fields.name.active && !name.trim()) {
            return false;
        }
        if (fields.email.active &&
            (!email.trim() ||
                !document.getElementById('email').checkValidity())) {
            return false;
        }
        if (fields.phone.active && !phone.trim()) {
            return false;
        }
        if (fields.message.active && !message.trim()) {
            return false;
        }
        return true;
    };
    var submitHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isFormOk()) {
                        setShowMessageFormError(true);
                        return [2 /*return*/];
                    }
                    setShowMessageFormError(false);
                    setSubmitting(true);
                    setShowModal(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, callSubmitApi()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onExitSuccessModal = function () {
        setShowModal(false);
        setName('');
        setEmail('');
        setPhone('');
        setMessage('');
    };
    var onSuccessLinkClick = function () {
        window.open(section.successRedirectLink);
        onExitSuccessModal();
    };
    var callSubmitApi = function () {
        var _a, _b;
        if ((_a = contextProps.form) === null || _a === void 0 ? void 0 : _a.submitUrl) {
            return fetch((_b = contextProps.form) === null || _b === void 0 ? void 0 : _b.submitUrl, {
                method: 'POST',
                body: JSON.stringify({
                    name: name,
                    email: email,
                    phone: phone,
                    message: message,
                }),
            });
        }
        return new Promise(function (resolve) {
            setTimeout(resolve, 2 * 1000);
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(SectionContainer, { children: [_jsx(SectionTitle, __assign({ className: classNames({
                            nmb: showMessageFormError,
                        }) }, { children: section.pageTitle }), void 0), _jsxs(ContentContainer, __assign({ invalidSvgIcon: invalidFormSvgUrl, showFormErrors: showMessageFormError }, { children: [showMessageFormError && _jsx("p", { children: contextProps.form.invalid }, void 0), _jsxs("form", __assign({ action: "" }, { children: [fields.name.active && (_jsx(FormGroup, { children: _jsx("input", { required: true, type: "text", id: "name", name: "name", placeholder: contextProps.form.fields.name, value: name, onChange: function (e) { return setName(e.target.value); }, tabIndex: 1 }, void 0) }, void 0)), fields.email.active && (_jsx(FormGroup, { children: _jsx("input", { required: true, type: "email", id: "email", name: "email", autoComplete: "off", placeholder: contextProps.form.fields.email, value: email, onChange: function (e) { return setEmail(e.target.value); }, tabIndex: 2 }, void 0) }, void 0)), fields.phone.active && (_jsx(FormGroup, { children: _jsx(InputMask, { required: true, mask: "+99 (99) 9 9999-9999", type: "tel", id: "phoneNotASearchField", name: "phoneNotASearchField", autoComplete: "off", placeholder: contextProps.form.fields.phone, value: phone, onChange: function (e) { return setPhone(e.target.value); }, tabIndex: 3 }, void 0) }, void 0)), fields.message.active && (_jsx(FormGroup, { children: _jsx("textarea", { required: true, id: "message", name: "message", placeholder: contextProps.form.fields.message, spellCheck: "false", onInput: function (e) {
                                                setMessage(e.currentTarget.value);
                                                autoResizeTextArea(e);
                                            }, rows: 1, value: message, tabIndex: 4 }, void 0) }, void 0)), _jsx(Button, __assign({ className: "submitButton", onClick: function () { return submitHandler(); }, onKeyPress: function () { return submitHandler(); }, backgroundColor: theme.buttons, textColor: theme.textButtons, tabIndex: 5 }, { children: section.buttonText }), void 0)] }), void 0)] }), void 0)] }, void 0), showModal && (_jsx(Modal, __assign({ onExit: isSubmitting ? undefined : onExitSuccessModal }, { children: isSubmitting ? (_jsx(Spinner, { color: theme.primary }, void 0)) : (_jsx(SuccessModalContent, { section: section, onLinkClick: onSuccessLinkClick, contextProps: contextProps }, void 0)) }), void 0))] }, void 0));
};
